import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const jinaAi = defineConnector({
  identifier: "jinaAi",
  name: "Jina AI",
  tagLine: "Search and embedding APIs",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: () => "https://.*\\.jina\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Jina AI](https://jina.ai/) and navigate to your API keys page to create a new key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.jina.ai/v1/models",
  },
});
